import { Grid, Chip } from "@mui/material";
import React from "react";

const FilterChips = ({ selectedStatuses, filterOptions, toggleStatus }) => {
  return (
    <Grid container spacing={1} sx={{ mb: 2 }}>
      {filterOptions?.map((status) => (
        <Grid item key={status} xs={6} sm={4} md={3} lg={2}>
          <Chip
            label={status}
            onClick={() => toggleStatus(status)}
            sx={{
              cursor: "pointer",
              width: "100%",
              backgroundColor: selectedStatuses.includes(status)
                ? "#0044C6"
                : "white",
              color: selectedStatuses.includes(status) ? "white" : "black",
              border: selectedStatuses.includes(status)
                ? "none"
                : "1px solid #ddd",
              "&:hover": {
                backgroundColor: selectedStatuses.includes(status)
                  ? "#0033A0"
                  : "#f0f0f0",
              },
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
};

export default FilterChips;